import { BaseRelationView } from "./../views/partials/base-relation";
import { RestrictedEUBaseRelationView } from "./../views/partials/restricted-eu-base-relation";
import { MiscRelationsView } from "./../views/tabs/misc-relations";
import { MiscRelationsTabModel } from "./../models/tabs/misc-relations";
import { GenericRelationView } from "./../views/partials/generic-relation";
import { CategoryDocumentListTabView } from "./../views/tabs/category-doc-list-tab";
import { CategoryTrendingGraphView } from "./../views/tabs/category-trending-graph";
import { CategoryCaseRelationView } from "./../views/partials/category-case-relation";
import { CategoryLegislationRelationView } from "./../views/partials/category-legislation-relation";
import { LegislationLatestRevisionView } from "./../views/tabs/legislation-latest-revision";
import { AsEnactedView } from "./../views/tabs/as-enacted";
import { AmendedItemRelationView } from "./../views/partials/amended-item-relation";
import { AmendingItemRelationView } from "./../views/partials/amending-item-relation";
import { CICListTabView } from "./../views/tabs/cic-list-tab";
import { LegislationOverviewTabView } from "./../views/tabs/legislation-overview";
import { CitationsAndSourcesTabView } from "./../views/tabs/citations-and-sources";
import { PublisherLinkListsView } from "./../views/partials/publisher-link-lists";
import { PublisherLinkListView } from "./../views/partials/publisher-link-list";
import { ReportTabView } from "./../views/tabs/report";
import { CiteLineListTabView } from "./../views/tabs/citeline-list-tab";
import { JudgmentTabView } from "./../views/tabs/judgment";
import { GenericTabView } from "../views/tabs/generic-tab";
import { GenericListTabView } from "../views/tabs/generic-list-tab";
import { CaseOverviewTabView } from "../views/tabs/case-overview";
import { CaseCategoriesTabView } from "../views/tabs/case-categories";
import { CitingCaseRelationView } from "../views/partials/citing-case-relation";
import { CitedCaseRelationView } from "../views/partials/cited-case-relation";
import { LegislationRelationView } from "../views/partials/legislation-relation";

import { LegislationOutlineView } from "./../views/tabs/legislation-outline";

export const TabViewDictionary: {[id: string]: any} = {
    GenericTabView : GenericTabView,
    GenericListTabView : GenericListTabView,
    CICListTabView: CICListTabView,
    CiteLineListTabView : CiteLineListTabView,
    CaseOverviewTabView : CaseOverviewTabView,
    CitedCaseRelationView : CitedCaseRelationView,
    LegislationRelationView : LegislationRelationView,
    CitingCaseRelationView : CitingCaseRelationView,
    CaseCategoriesTabView : CaseCategoriesTabView,
    LegislationOverviewTabView: LegislationOverviewTabView,
    JudgmentTabView : JudgmentTabView,
    ReportTabView: ReportTabView,
    PublisherLinkListView: PublisherLinkListView,
    CitationsAndSourcesTabView: CitationsAndSourcesTabView,
    AmendingItemRelationView: AmendingItemRelationView,
    AmendedItemRelationView: AmendedItemRelationView,
    AsEnactedTabView: AsEnactedView,
    GenericView: Marionette.ItemView,
    LegislationLatestRevisionView: LegislationLatestRevisionView,
    CategoryLegislationRelationView: CategoryLegislationRelationView,
    CategoryCaseRelationView: CategoryCaseRelationView,
    CategoryTrendingGraphView: CategoryTrendingGraphView,
    CategoryDocumentListTabView: CategoryDocumentListTabView,
    GenericRelationView: GenericRelationView,
    MiscRelationsView: MiscRelationsView,
    MiscCitedRelationsView: MiscRelationsView, // we use the same classes here but want different names for slightly different functionality
    MiscCitingRelationsView: MiscRelationsView,
    BaseRelationView: BaseRelationView,
    RestrictedEUBaseRelationView: RestrictedEUBaseRelationView,
    LegislationOutlineView: LegislationOutlineView
};



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/helpers/tab-view-dictionary.ts